/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProfileSearchFilters } from '../models/ProfileSearchFilters';
import type { ProfileSearchResponse } from '../models/ProfileSearchResponse';
import type { RecentSearchFilters } from '../models/RecentSearchFilters';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SearchService {
    /**
     * Search Profiles
     * @param requestBody
     * @param cursor
     * @returns ProfileSearchResponse Successful Response
     * @throws ApiError
     */
    public static searchProfilesApiSearchPost(
        requestBody: ProfileSearchFilters,
        cursor?: (string | null),
    ): CancelablePromise<ProfileSearchResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/search/',
            query: {
                'cursor': cursor,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Recent Search
     * @returns any Successful Response
     * @throws ApiError
     */
    public static recentSearchApiSearchRecentGet(): CancelablePromise<(RecentSearchFilters | null)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/search/recent',
        });
    }
}
